import { useAtomValue } from 'jotai';

import { communityShowAuthModalAtom } from '@/services/globalState';

/** Whether the sign-in prompt that gated actions open is showing over the Inquiry Library. */
export function useCommunityAuthModalShown() {
  return useAtomValue(communityShowAuthModalAtom);
}
